import Tag from '../../components/lozenge/tags';
import { ActionButton } from '../../components/vertical-dot/popper';

export const TermAndConditionHeader = ({
  actions,
  tableActions,
}: {
  actions?: any;
  tableActions?: any;
}): any[] => {
  const getActions = (rowData: Record<string, string>): any => {
    let newActions = [];
    if (rowData.status === 'Pending') {
      newActions = tableActions.filter((item: any) => item.action !== 'View Remarks');
    } else if (rowData.status === 'Approved') {
      newActions = tableActions.filter((item: any) => item.action !== 'View Remarks');
    } else if (rowData.status === 'Rejected') {
      newActions = tableActions.filter((item: any) =>
        ['View Remarks', 'View'].includes(item.action)
      );
    } else {
      newActions = tableActions;
    }

    if (rowData.customerRole === 'Admin' || rowData.customerTitle === '') {
      newActions = tableActions.filter((item: any) => ['View'].includes(item.action));
    }
    return newActions;
  };
  const newActions = [
    ...(actions || []),
    {
      Header: '',
      accessor: 'actions',
      width: 20,
      center: true,
      sortable: false,
      isSubHeader: false,
      renderCell: true,
      Cell: ({ row }: any) => {
        const actions = getActions(row?.original);
        // console.log("Actions", row.original, actions);

        return (
          <td>
            <ActionButton
              actions={actions}
              id={row?.original?.id}
              rowData={row?.original}
              counter={parseInt(row?.id)}
            />
          </td>
        );
      },
    },
  ];

  return newActions;
  return [
    {
      Header: 'Name',
      accessor: 'name',
      width: 300,
      sortable: false,
    },
    {
      Header: 'Page Name',
      accessor: 'page',
      width: 300,
      sortable: false,
    },
    {
      Header: 'Status',
      accessor: 'statusId',
      width: 200,
      sortable: false,
      Cell: ({ row }: any) => (
        <Tag
          variant={row.original.isActive === true ? 'success' : 'error'}
          title={row.original.isActive === true ? 'Active' : 'Inactive'}
        />
      ),
    },
    {
      Header: '',
      accessor: 'actions',
      width: 20,
      sortable: false,
      Cell: ({ row }: any) => (
        <ActionButton
          actions={getActions(row.original)}
          id={row.original.id}
          rowData={row.original}
          counter={parseInt(row?.id)}
        />
      ),
    },
  ];
};
